// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__J_Ymt","title":"style_title__1oT2V","icon":"style_icon__1zbHt","item":"style_item__2DNZ6"};